import React from 'react';
import { useTranslation } from 'react-i18next';

const PasswordRequirements = ({ password, show }) => {
	const { t } = useTranslation();

	// Evaluate requirements
	const lengthValid = password.length >= 6;
	const capitalValid = /[A-Z]/.test(password);
	const numberValid = /[0-9]/.test(password);
	const spacesValid = !/\s/.test(password);

	return (
		<div
			id="password-requirements"
			className={`tooltip bs-tooltip-left${show ? ' show' : ''} position-absolute`}
			role="tooltip"
			style={{
				top: '50%',
				right: '100%',
				transform: 'translateY(-50%) translateX(-0.4rem)',
				width: '220px',
				whiteSpace: 'nowrap'
			}}
		>
			<div className="tooltip-arrow"></div>
			<div className="tooltip-inner">
				<p className="mb-2 fw-bold">{t('需包含：')}</p>
				<ul className="ps-3 mb-0">
					<li className="req-length">
						<span className={`icon ${lengthValid ? 'text-success' : 'text-danger'}`}>
							{lengthValid ? '✓' : '✗'}
						</span> {t('最少 6 個字元')}
					</li>
					<li className="req-capital">
						<span className={`icon ${capitalValid ? 'text-success' : 'text-danger'}`}>
							{capitalValid ? '✓' : '✗'}
						</span> {t('至少一個大寫字母')}
					</li>
					<li className="req-number">
						<span className={`icon ${numberValid ? 'text-success' : 'text-danger'}`}>
							{numberValid ? '✓' : '✗'}
						</span> {t('至少一個數字')}
					</li>
					<li className="req-spaces">
						<span className={`icon ${spacesValid ? 'text-success' : 'text-danger'}`}>
							{spacesValid ? '✓' : '✗'}
						</span> {t('不得包含空白')}
					</li>
				</ul>
			</div>
		</div>
	);
};

export default PasswordRequirements;

